/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Dominik Boeck <d.boeck@techdivision.com>
 */

// Create the dataLayer container, if is not already created
window.dataLayer = window.dataLayer || [];

const stepEventMapping = ['StudioStep', 'ContractStep', 'ContactStep', 'PaymentStep', 'PreviewStep', 'SuccessStep'];

/**
 * If the contract were successfully created, push den information to the datalayer
 * @param response
 * @param requestArguments
 * @param formValues
 */
const pushPurchaseToDatalayer = (response, requestArguments, formValues) => {
  // Push purchase event into dataLayer
  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'purchase',
      ecommerce: {
        transaction_id: response?.id,
        value: formValues?.rateBundleTerm?.contractVolumeInformation?.totalContractVolume,
        currency: 'EUR',
        coupon: requestArguments?.voucherCode,
        contract_runtime: formValues?.rateBundleTerm?.termValue,
        country_code: formValues?.studio?.address?.countryCode,
        billing_email: requestArguments?.customer?.email,
        items: [
          {
            item_id: requestArguments?.contract?.rateBundleTermId,
            item_name: formValues?.rateBundle?.name,
            affiliation: requestArguments?.customer?.referralCode,
            coupon: requestArguments?.voucherCode,
            index: 0,
            location_id: requestArguments?.studioId,
            price: formValues?.rateBundleTerm?.price,
            quantity: formValues?.rateBundleTerm?.termValue,
          },
        ],
      },
    });
  }
};

/**
 * Push the step switch information to the Google datalayer
 * @param stepKey
 */
const pushStepToDatalayer = (stepKey) => {
  if (!(stepKey in stepEventMapping)) {
    return;
  }
  // Push purchase event into dataLayer
  if (window.dataLayer) {
    window.dataLayer.push({ event: `select${stepEventMapping[stepKey]}` });
  }
};

export default {
  pushPurchaseToDatalayer,
  pushStepToDatalayer,
};
